import React from 'react';

interface UploadIconProps {
    width?: number;
    height?: number;
    fill?: string;
}

const UploadFileIcon = ({ width = 35, height = 34, fill = "#3674EE" }: UploadIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 35 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2348_52882)">
                <path
                    d="M28.8281 12.4981C27.2567 6.23814 20.9083 2.43733 14.6483 4.00873C9.75629 5.23678 6.20415 9.46487 5.83815 14.4953C2.36462 15.0681 0.0131049 18.3483 0.585929 21.8219C1.09514 24.9099 3.77089 27.1714 6.90054 27.1589H12.2125V25.0342H6.90054C4.5536 25.0342 2.651 23.1316 2.651 20.7846C2.651 18.4377 4.5536 16.5351 6.90054 16.5351C7.48731 16.5351 7.96292 16.0595 7.96292 15.4727C7.95761 10.1921 12.2342 5.90694 17.5148 5.9017C22.086 5.89712 26.021 9.12876 26.9052 13.6135C26.9925 14.0613 27.3559 14.4034 27.8083 14.4635C30.7127 14.877 32.7318 17.5668 32.3183 20.4712C31.9469 23.0792 29.7201 25.021 27.0858 25.0342H22.8363V27.1589H27.0858C31.193 27.1465 34.5124 23.8069 34.4999 19.6997C34.4896 16.2809 32.1494 13.3094 28.8281 12.4981Z"
                    fill={fill}
                />
                <path
                    d="M16.77 16.8431L12.5205 21.0927L14.0185 22.5906L16.462 20.1578V30.346H18.5867V20.1578L21.0196 22.5906L22.5175 21.0927L18.268 16.8431C17.8536 16.4312 17.1844 16.4312 16.77 16.8431Z"
                    fill={fill}
                />
            </g>
            <defs>
                <clipPath id="clip0_2348_52882">
                    <rect width="34" height="34" fill="white" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default UploadFileIcon;
